/* eslint-disable indent */
/* global $ */

export default ({
  widgetParams,
  isFirstPage,
  isLastPage,
  pages,
  currentRefinement,
  nbPages,
  refine,
  createURL,
}) => {
  const numberToShow = 99;
  let previous_label = widgetParams.locale === 'zh' ? '前一页' : 'Previous';
  let next_label     = widgetParams.locale === 'zh' ? '下一页' : 'Next';

  $(widgetParams.container).html(`
  <div class="archive-pagination__previous ${isFirstPage ? 'archive-pagination__disabled' : ''}">
    <button
      data-value="${currentRefinement - 1}"
      class="archive-pagination__link">
      ${previous_label}
    </button>
  </div>
  <div class="pagination-pages">
    <ul class="pagination-pages-list">
      ${pages
        .map(page => {
          if (currentRefinement + numberToShow < page || currentRefinement - numberToShow > page) {
            if (page === nbPages - 1) {
              return `<li class="pagination-list-item">
                  ${
                    currentRefinement + numberToShow + 1 === nbPages - 1
                      ? ''
                      : `<span class="pagination-ellipsis"> &hellip; </span>`
                  }
                  <button
                    data-value="${page}"
                    class="pagination-list-item--link">
                    ${page + 1}
                  </button>
                </li>`;
            } else if (page === 0) {
              return `<li class="pagination-list-item">
                  <button
                    data-value="${page}"
                    class="pagination-list-item--link">
                    ${page + 1}
                  </button>
                  ${
                    currentRefinement - numberToShow - 1 === 0
                      ? ''
                      : `<span class="pagination-ellipsis"> &hellip; </span>`
                  }
                </li>`;
            }
            return;
          }

          return `
            <li class="pagination-list-item ${
              currentRefinement === page ? 'pagination-list-item--current' : ''
            }">
              <button
                data-value="${page}"
                class="pagination-list-item--link">
                ${page + 1}
              </button>
            </li>
          `;
        })
        .join('')}
    </ul>
  </div>
  <div class="archive-pagination__next ${isLastPage ? 'archive-pagination__disabled' : ''}">
    <button
      data-value="${currentRefinement + 1}"
      class="archive-pagination__link">
      ${next_label}
    </button>
  </div>
  `);

  [...widgetParams.container.find('button')].forEach(element => {
    element.addEventListener('click', event => {
      event.preventDefault();
      refine(event.currentTarget.dataset.value);
      window.scrollTo({
        top: $('.ais-InstantSearch').position().top,
        behavior: 'smooth',
      });
    });
  });
};
